/* tslint:disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpRequest, HttpResponse, HttpHeaders } from '@angular/common/http';
import { BaseService as __BaseService } from '../base-service';
import { ObjectObjectConfiguration as __Configuration } from '../object-object-configuration';
import { StrictHttpResponse as __StrictHttpResponse } from '../strict-http-response';
import { Observable as __Observable } from 'rxjs';
import { map as __map, filter as __filter } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
class PaymentService extends __BaseService {
  static readonly getPlansPath = '/plans';
  static readonly buySubscriptionPath = '/payment';
  static readonly changeCreditCardPath = '/card';
  static readonly paymentRenewInfoPath = '/plans/renew';

  constructor(
    config: __Configuration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Get plans for payment.
   * @param lang Language short code.
   */
  getPlansResponse(lang?: string): __Observable<__StrictHttpResponse<null>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (lang != null) __params = __params.set('lang', lang.toString());
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/plans`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<null>;
      })
    );
  }
  /**
   * Get plans for payment.
   * @param lang Language short code.
   */
  getPlans(lang?: string): __Observable<null> {
    return this.getPlansResponse(lang).pipe(
      __map(_r => _r.body as null)
    );
  }

  /**
   * Buy subscription.
   * @param params The `PaymentService.BuySubscriptionParams` containing the following parameters:
   *
   * - `Authorization`:
   *
   * - `body`: Payment body card, plans
   */
  buySubscriptionResponse(params: PaymentService.BuySubscriptionParams): __Observable<__StrictHttpResponse<null>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (params.Authorization != null) __headers = __headers.set('Authorization', params.Authorization.toString());
    __body = params.body;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/payment`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<null>;
      })
    );
  }
  /**
   * Buy subscription.
   * @param params The `PaymentService.BuySubscriptionParams` containing the following parameters:
   *
   * - `Authorization`:
   *
   * - `body`: Payment body card, plans
   */
  buySubscription(params: PaymentService.BuySubscriptionParams): __Observable<null> {
    return this.buySubscriptionResponse(params).pipe(
      __map(_r => _r.body as null)
    );
  }

  /**
   * Change credit card.
   * @param params The `PaymentService.ChangeCreditCardParams` containing the following parameters:
   *
   * - `Authorization`:
   *
   * - `body`: Payment body card
   */
  changeCreditCardResponse(params: PaymentService.ChangeCreditCardParams): __Observable<__StrictHttpResponse<null>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (params.Authorization != null) __headers = __headers.set('Authorization', params.Authorization.toString());
    __body = params.body;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/card`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<null>;
      })
    );
  }
  /**
   * Change credit card.
   * @param params The `PaymentService.ChangeCreditCardParams` containing the following parameters:
   *
   * - `Authorization`:
   *
   * - `body`: Payment body card
   */
  changeCreditCard(params: PaymentService.ChangeCreditCardParams): __Observable<null> {
    return this.changeCreditCardResponse(params).pipe(
      __map(_r => _r.body as null)
    );
  }

  /**
   * Get payment info
   * @param params The `PaymentService.PaymentRenewInfoParams` containing the following parameters:
   *
   * - `Authorization`:
   *
   * - `lang`: Language short code.
   */
  paymentRenewInfoResponse(params: PaymentService.PaymentRenewInfoParams): __Observable<__StrictHttpResponse<null>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (params.Authorization != null) __headers = __headers.set('Authorization', params.Authorization.toString());
    if (params.lang != null) __params = __params.set('lang', params.lang.toString());
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/plans/renew`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<null>;
      })
    );
  }
  /**
   * Get payment info
   * @param params The `PaymentService.PaymentRenewInfoParams` containing the following parameters:
   *
   * - `Authorization`:
   *
   * - `lang`: Language short code.
   */
  paymentRenewInfo(params: PaymentService.PaymentRenewInfoParams): __Observable<null> {
    return this.paymentRenewInfoResponse(params).pipe(
      __map(_r => _r.body as null)
    );
  }
}

module PaymentService {

  /**
   * Parameters for buySubscription
   */
  export interface BuySubscriptionParams {
    Authorization: string;

    /**
     * Payment body card, plans
     */
    body?: {};
  }

  /**
   * Parameters for changeCreditCard
   */
  export interface ChangeCreditCardParams {
    Authorization: string;

    /**
     * Payment body card
     */
    body?: {};
  }

  /**
   * Parameters for paymentRenewInfo
   */
  export interface PaymentRenewInfoParams {
    Authorization: string;

    /**
     * Language short code.
     */
    lang?: string;
  }
}

export { PaymentService }
